export default {
  alternativeLanguageVersions: [
    'de',
    'es',
    'fr',
    'it',
    'pt'
  ],
}
